export default "__VITE_ASSET__cmXHWZzq__"